<!-- 顶部导航条 -->
<template>
  <div>
    <!-- 顶部导航栏 -->
    <div class="topbar">
      <div class="nav-container">
        <!-- 左侧信息 -->
        <div class="nav-left">
          <span class="mobile-link">
            <i class="el-icon-mobile-phone"></i>手机版
          </span>
          <span class="welcome">
            欢迎来到<span class="brand">绒博汇</span>官网
          </span>
        </div>

        <!-- 中间登录/用户区 -->
        <div class="nav-center" v-if="!this.$store.getters.getUser">
          <a class="login-link" @click="login">请登录</a>
          <span class="sep">|</span>
          <a class="register-link" @click="register = true">注册</a>
        </div>
        <div class="nav-center usercenter" v-else>
          <router-link to="/ucenter" target="_blank" class="username">
            [ {{ this.$store.getters.getUser.username }} ]
          </router-link>
          <a class="logout-link" @click="visible = true">[退出]</a>
          <el-dialog title="退出确认" width="30%" :visible.sync="visible" center>
            <p class="logout-msg">确定退出登录吗？</p>
            <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="visible = false">取消</el-button>
              <el-button type="danger" size="small" @click="logout">确定</el-button>
            </div>
          </el-dialog>
        </div>

        <!-- 右侧导航 -->
        <div class="nav-right">
          <router-link to="/ucenter" target="_blank" class="nav-item">会员中心</router-link>
          <span class="divider">|</span>
          <router-link to="/order" class="nav-item">我的订单</router-link>
          <span class="divider">|</span>
          <router-link to="/collect" class="nav-item">我的收藏</router-link>
          <span class="divider">|</span>
          <router-link to="/readme" class="nav-item">用户须知</router-link>
        </div>
      </div>
    </div>
    <!-- 顶部导航栏END -->

    <!-- 登录模块 -->
    <MyLogin></MyLogin>
    <!-- 注册模块 -->
    <MyRegister :register="register" @fromChild="isRegister"></MyRegister>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  name: "TopBar",
  data() {
    return {
      register: false, // 是否显示注册组件
      visible: false, // 是否退出登录
    };
  },
  created() {
    // 判断用户是否已经登录
    if (
      localStorage.getItem("user") &&
      localStorage.getItem("user") != "undefined"
    ) {
      // 设置vuex登录状态
      this.setUser(JSON.parse(localStorage.getItem("user")));
    }
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {
    // 获取vuex的登录状态
    getUser: function (val) {
      if (val === "") {
        // 用户没有登录
        this.setShoppingCart([]);
        this.setCartTotalCount(0);
      } else {
        // 获取购物车信息
        this.$axios
          .post(this.$newApi + "/api/rbh/cart/list", {
            uid: val.id,
          })
          .then((response) => {
            // 兼容接口返回格式：数组（旧格式）或 { list, totalCount }（分页格式）
            const data = response.data.data;
            const list = Array.isArray(data) ? data : data.list || [];
            const cartList = list.map((item) => {
              let cart = item.goods_info;
              cart.check = false;
              return cart;
            });
            this.setShoppingCart(cartList);
            // 同步购物车总条数，供顶部角标展示
            this.setCartTotalCount(
              Array.isArray(data) ? list.length : data.totalCount || data.total || list.length
            );
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }
    },
  },
  methods: {
    ...mapActions(["setUser", "setShowLogin", "setShoppingCart", "setCartTotalCount"]),
    /**
     * 登录，更改vuex的showLogin值显示登录组件
     */
    login() {
      this.setShowLogin(true);
    },
    /**
     * 退出登录
     */
    logout() {
      this.visible = false;
      // 清空本地登录信息
      localStorage.setItem("user", "");
      // 清空vuex登录信息
      this.setUser("");
      this.notifySucceed("成功退出登录");
    },
    /**
     * 接收注册子组件传过来的数据,显示或隐藏注册控件
     * @param {*} val 
     */
    isRegister(val) {
      this.register = val;
    },
  },
};
</script>

<style scoped>
/* 顶部导航栏CSS */
.topbar {
  height: 40px;
  background: linear-gradient(90deg, #2d3436 0%, #1a1a2e 100%);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.nav-container {
  width: 1240px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

/* 左侧信息 */
.nav-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.mobile-link {
  display: flex;
  align-items: center;
  gap: 5px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  transition: color 0.3s;
}

.mobile-link:hover {
  color: #fff;
}

.mobile-link i {
  font-size: 14px;
}

.welcome {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
}

.brand {
  background: linear-gradient(135deg, #ff6b6b, #feca57);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 600;
  margin: 0 3px;
}

/* 中间登录区 */
.nav-center {
  display: flex;
  align-items: center;
  gap: 8px;
}

.login-link,
.register-link {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: all 0.3s;
  padding: 4px 8px;
  border-radius: 4px;
}

.login-link:hover {
  color: #fff;
  background: rgba(255, 107, 107, 0.2);
}

.register-link:hover {
  color: #ff6b6b;
  background: rgba(255, 107, 107, 0.1);
}

.sep {
  color: rgba(255, 255, 255, 0.3);
  font-size: 12px;
}

/* 用户中心 */
.usercenter .username {
  color: #ff6b6b !important;
  font-weight: 500;
  transition: color 0.3s;
}

.usercenter .username:hover {
  color: #fff !important;
}

.logout-link {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  cursor: pointer;
  transition: color 0.3s;
}

.logout-link:hover {
  color: #ff6b6b;
}

/* 右侧导航 */
.nav-right {
  display: flex;
  align-items: center;
}

.nav-item {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 4px;
  transition: all 0.3s;
  text-decoration: none;
}

.nav-item:hover {
  color: #fff;
  background: rgba(255, 107, 107, 0.15);
}

.divider {
  color: rgba(255, 255, 255, 0.2);
  font-size: 12px;
}

/* 退出弹窗样式 */
.logout-msg {
  text-align: center;
  font-size: 16px;
  color: #333;
}

.dialog-footer {
  text-align: center;
}

/* Element UI 覆盖样式 */
.topbar >>> .el-dialog {
  border-radius: 12px;
}

.topbar >>> .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
}

.topbar >>> .el-dialog__title {
  font-weight: 600;
  color: #333;
}

.topbar >>> .el-dialog__body {
  padding: 30px 20px;
}

.topbar >>> .el-dialog__footer {
  border-top: 1px solid #eee;
  padding: 15px 20px;
}
</style>
